import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
export function WhoWeAre() {
  const forWho = ["You're building something—but want clarity on your next move", "You're looking for funding, grants, or the right programs", 'You want mentorship and community without overwhelm', "You're ready to take yourself—and your business—seriously"];
  return <section className="py-24 lg:py-32 bg-cream overflow-hidden" data-id="element-194">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-195">
        <div className="lg:col-span-5" data-id="element-196">
          <FadeIn className="sticky top-32" data-id="element-197">
            <h2 className="text-5xl md:text-6xl font-bold mb-8 text-navy leading-tight" data-id="element-198">
              Who This <br data-id="element-199" />
              <em className="font-light italic text-forest" data-id="element-200">Community</em> Is
              For
            </h2>
            <div className="w-24 h-1 bg-forest mb-8" data-id="element-201"></div>
            <p className="text-xl text-body leading-relaxed" data-id="element-202">
              LeadHerShip Equity is built for women who are ready to take
              themselves seriously as builders.
            </p>
          </FadeIn>
        </div>

        <div className="lg:col-span-7 relative" data-id="element-203">
          {/* Tile Disruption Layout */}

          <div className="relative z-10 mb-12 lg:mb-0 lg:translate-x-8" data-id="element-204">
            <FadeIn delay={0.1} className="bg-forest text-cream p-10 md:p-14 shadow-2xl" data-id="element-205">
              <h3 className="text-2xl font-serif mb-8 text-gold-light italic" data-id="element-206">
                Women who are:
              </h3>
              <StaggerContainer className="space-y-6" data-id="element-207">
                {forWho.map((item, index) => <StaggerItem key={index} className="flex items-start" data-id="element-208">
                    <span className="text-gold-light mr-4 text-xl mt-1" data-id="element-209">—</span>
                    <span className="text-lg md:text-xl text-cream/90 font-light" data-id="element-210">
                      {item}
                    </span>
                  </StaggerItem>)}
              </StaggerContainer>
            </FadeIn>
          </div>

          <div className="relative z-20 lg:-mt-24 lg:-translate-x-12" data-id="element-211">
            <FadeIn delay={0.3} className="bg-navy text-cream p-10 md:p-14 shadow-2xl" data-id="element-212">
              <h3 className="text-sm tracking-widest uppercase mb-6 text-cream/60" data-id="element-213">
                Not Another Women's Group
              </h3>
              <p className="text-3xl md:text-4xl font-serif font-bold leading-tight mb-8 text-white" data-id="element-214">
                FundHER Academy is for the women who are asking:
              </p>
              <div className="space-y-4 text-cream/80 font-light text-lg" data-id="element-215">
                <p data-id="element-216">How do I actually get funded?</p>
                <p className="text-gold-light font-medium" data-id="element-217">
                  How do I find the right rooms?
                </p>
                <p className="text-cream/90 mt-2" data-id="element-218">
                  How do I build with real strategy behind me?
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}